module.exports = __webpack_public_path__ + "static/img/tx.ecec4814.jpg";